import React, {useEffect, useState} from "react";
import useWidth from "../hooks/useWidth";
import {Button, Box, Typography, Grid} from "@mui/material";
import AnomalyDetectionRecordsComponent from "../components/anomaly-detection/anomaly-detection-records.component";
import DateRangePickerComponent from "../components/common/CustomDateRangePicker";
import moment from "moment";
import ListIcon from "../assets/icons/list.png";
import {useNavigate} from "react-router-dom";
import AnomalyLocationsComponent from "../components/anomaly-detection/anomaly-locations.component";
import useAnomalyDetection from "../hooks/useAnomalyDetection";

function getVerificationLogs(anomalyDetectionList){
    var data = [];
    if(anomalyDetectionList.length != 0){
        anomalyDetectionList.map((anomaly)=>{
            anomaly.verificationLogs.map((element)=>{
                console.log("element: ", JSON.stringify(element))
                data.push(element);
            })
        });
    }
    return data;
}

const AnomalyDetectionScreen = () => {

    const breakpoints = useWidth();
    const navigate = useNavigate();

    const {anomalyDetectionList, getAnomalyDetectionList, isFetchingAnomalyDetectionList} = useAnomalyDetection();

    const [selectedAnomaly, setSelectedAnomaly] = useState();
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [verificationLogs, setVerificationLogs] = useState([]);
    const [formattedSelectedAnomaly, setFormattedSelectedAnomaly] = useState(null);


    useEffect(() => {
        getAnomalyDetectionList(startDate, endDate);
    }, [startDate, endDate])

    useEffect(()=>{
        var verification_logs = getVerificationLogs(anomalyDetectionList);;
        setVerificationLogs(verification_logs);
    }, [anomalyDetectionList])

    useEffect(()=>{
        if(selectedAnomaly == null) return;
        var arr = [];
        arr.push(selectedAnomaly);
        var verification_logs = getVerificationLogs(arr);
        console.log("here verification_logs: ", verification_logs.length)
        setFormattedSelectedAnomaly(verification_logs);
    }, [selectedAnomaly])
    
    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleViewList = (e) => {
        navigate("/anomaly-detection/list");
    }


    return (
        <Box>
            <Grid>
                <Typography variant="h6" sx={{color: "#58565f", fontWeight: 600, fontSize: 20}}>
                    Anomaly Detection
                </Typography>
            </Grid>

            <Grid container sx={{mt: 3, mb: 3}}>
                <Grid xs={3} sm={3} md={3} lg={3} xl={3}> 
                    <Typography sx={{color: "#58565f", fontSize: 18}}>
                        Anomaly Records
                    </Typography>
                </Grid>

                <Grid xs={9} sm={9} md={9} lg={9} xl={9} sx={{display: "flex", justifyContent: "end"}}>
                    <DateRangePickerComponent 
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                        ranges={{
                            "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                            "This Month": [moment().startOf('month'), moment().endOf('month')],
                            "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                        }}
                        onDateRangeChange={handleDateRangeChange}
                    />

                    &nbsp; &nbsp;

                    <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                        startIcon={<img alt="list-icon" src={ListIcon} style={{height: 18}} />}
                        onClick={(e) => handleViewList(e)}
                    >
                        See List View
                    </Button>
                </Grid>
            </Grid>

            <Grid container>
                <Grid xs={6} sm={6} md={6} lg={6} xl={6} sx={{backgroundColor: "#fff", padding: 3, borderRadius: "6px"}}>
                    {isFetchingAnomalyDetectionList ? 
                        <>Loading . . .</> 
                    : 
                        <AnomalyDetectionRecordsComponent 
                            breakpoints={breakpoints} 
                            anomalyDetectionList={anomalyDetectionList} 
                            onClickVisibilityIcon={(res)=>setSelectedAnomaly(res)}
                        />
                    }
                </Grid>

                <Grid xs={6} sm={6} md={4} lg={6} xl={6}>
                    <AnomalyLocationsComponent breakpoints={breakpoints} verificationLogs={verificationLogs} selectedAnomaly={formattedSelectedAnomaly}/> 
                </Grid>
            </Grid>
        </Box>
    )

}

export default AnomalyDetectionScreen